export default __webpack_public_path__ + "static/media/default.fecf65695708029f34ded9e3998f5719.png";